import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useProjectStore } from "@/stores/projects";
import { useClientStore } from "@/stores/clients";
import { useEmployeeStore } from "@/stores/employees";
import InnFilter from "@/components/general/Filter.vue";
import InnSelect from "@/components/ds/select/Select.vue";
import InnInput from "@/components/ds/input/Input.vue";
import InnCheckbox from "@/components/ds/checkbox/InnCheckbox.vue";
import { getYearList } from "@/tools/date";
import { useCompanyStore } from "@/stores/company";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectFilter',
  setup(__props) {

const projectsStore = useProjectStore();
const clientsStore = useClientStore();
const employeesStore = useEmployeeStore();
const companyStore = useCompanyStore();

const clients = [
    {
        id: "*",
        name: "Alle",
    },
    ...clientsStore.list,
];

const employees = [
    {
        id: "*",
        name: "Alle",
    },
    ...employeesStore.list,
];

const years = [
    "*",
    ...getYearList(
        companyStore.company ? companyStore.company.startingYear : 2020
    ),
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InnFilter, null, {
    default: _withCtx(() => [
      _createVNode(InnInput, {
        modelValue: _unref(projectsStore).search,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(projectsStore).search) = $event)),
        placeholder: "Zoeken..."
      }, null, 8, ["modelValue"]),
      _createVNode(InnSelect, {
        items: clients,
        modelValue: _unref(projectsStore).client_id,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(projectsStore).client_id) = $event)),
        "item-title": "name",
        "item-value": "id"
      }, null, 8, ["modelValue"]),
      _createVNode(InnSelect, {
        items: employees,
        modelValue: _unref(projectsStore).employee_id,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(projectsStore).employee_id) = $event)),
        "item-title": "name",
        "item-value": "id"
      }, null, 8, ["modelValue"]),
      _createVNode(InnSelect, {
        items: years,
        modelValue: _unref(projectsStore).year,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(projectsStore).year) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(InnCheckbox, {
        modelValue: _unref(projectsStore).liveProjects,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(projectsStore).liveProjects) = $event)),
        label: "Live projects"
      }, null, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})